import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";
import { DarkModeProvider } from "./contexts/DarkModeContext";
import { GoogleOAuthProvider } from "@react-oauth/google";

const clientId =
  "578190937716-rqa6emrnbifgbjv3b6rccbqbsjtj5bna.apps.googleusercontent.com";

const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={clientId}>
    <AgoraRTCProvider client={client}>
      <DarkModeProvider>
        <App />
      </DarkModeProvider>
    </AgoraRTCProvider>
  </GoogleOAuthProvider>
  // </React.StrictMode>
);
